// extracted by css-extract-rspack-plugin
export default {"page_not_found":"me7ih3sEhR811sas"};